import { gql } from '@apollo/client';

export const GET_FACEBOOK_AD_CREATIVE_PREVIEW = gql`
  query GetFacebookAdCreativePreviews(
    $creative_id: String!
    $ad_format: String!
    $user_socmed_id: String!
  ) {
    GetFacebookAdCreativePreviews(
      creative_id: $creative_id
      ad_format: $ad_format
      user_socmed_id: $user_socmed_id
    ) {
      data
    }
  }
`;

export const GET_FACEBOOK_AD_CREATIVE_BY_ID = gql`
  query GetFacebookAdCreative(
    $parameter: FacebookAdCreativeParameter!
    $ad_creative_id: String!
    $user_socmed_id: String!
  ) {
    GetFacebookAdCreative(
      parameter: $parameter
      ad_creative_id: $ad_creative_id
      user_socmed_id: $user_socmed_id
    ) {
      data
    }
  }
`;
